<app-header></app-header> <app-home></app-home><app-about></app-about
><app-projects></app-projects>
<app-skills></app-skills>
<app-contact></app-contact>
<app-footer></app-footer>